export { default as HeroAcademicCap } from './AcademicCap';
export { default as HeroAdjustmentsHorizontal } from './AdjustmentsHorizontal';
export { default as HeroAdjustmentsVertical } from './AdjustmentsVertical';
export { default as HeroArchiveBoxArrowDown } from './ArchiveBoxArrowDown';
export { default as HeroArchiveBoxXMark } from './ArchiveBoxXMark';
export { default as HeroArchiveBox } from './ArchiveBox';
export { default as HeroArrowDownCircle } from './ArrowDownCircle';
export { default as HeroArrowDownLeft } from './ArrowDownLeft';
export { default as HeroArrowDownOnSquareStack } from './ArrowDownOnSquareStack';
export { default as HeroArrowDownOnSquare } from './ArrowDownOnSquare';
export { default as HeroArrowDownRight } from './ArrowDownRight';
export { default as HeroArrowDownTray } from './ArrowDownTray';
export { default as HeroArrowDown } from './ArrowDown';
export { default as HeroArrowLeftCircle } from './ArrowLeftCircle';
export { default as HeroArrowLeftOnRectangle } from './ArrowLeftOnRectangle';
export { default as HeroArrowLeft } from './ArrowLeft';
export { default as HeroArrowLongDown } from './ArrowLongDown';
export { default as HeroArrowLongLeft } from './ArrowLongLeft';
export { default as HeroArrowLongRight } from './ArrowLongRight';
export { default as HeroArrowLongUp } from './ArrowLongUp';
export { default as HeroArrowPathRoundedSquare } from './ArrowPathRoundedSquare';
export { default as HeroArrowPath } from './ArrowPath';
export { default as HeroArrowRightCircle } from './ArrowRightCircle';
export { default as HeroArrowRightOnRectangle } from './ArrowRightOnRectangle';
export { default as HeroArrowRight } from './ArrowRight';
export { default as HeroArrowSmallDown } from './ArrowSmallDown';
export { default as HeroArrowSmallLeft } from './ArrowSmallLeft';
export { default as HeroArrowSmallRight } from './ArrowSmallRight';
export { default as HeroArrowSmallUp } from './ArrowSmallUp';
export { default as HeroArrowTopRightOnSquare } from './ArrowTopRightOnSquare';
export { default as HeroArrowTrendingDown } from './ArrowTrendingDown';
export { default as HeroArrowTrendingUp } from './ArrowTrendingUp';
export { default as HeroArrowUpCircle } from './ArrowUpCircle';
export { default as HeroArrowUpLeft } from './ArrowUpLeft';
export { default as HeroArrowUpOnSquareStack } from './ArrowUpOnSquareStack';
export { default as HeroArrowUpOnSquare } from './ArrowUpOnSquare';
export { default as HeroArrowUpRight } from './ArrowUpRight';
export { default as HeroArrowUpTray } from './ArrowUpTray';
export { default as HeroArrowUp } from './ArrowUp';
export { default as HeroArrowUturnDown } from './ArrowUturnDown';
export { default as HeroArrowUturnLeft } from './ArrowUturnLeft';
export { default as HeroArrowUturnRight } from './ArrowUturnRight';
export { default as HeroArrowUturnUp } from './ArrowUturnUp';
export { default as HeroArrowsPointingIn } from './ArrowsPointingIn';
export { default as HeroArrowsPointingOut } from './ArrowsPointingOut';
export { default as HeroArrowsRightLeft } from './ArrowsRightLeft';
export { default as HeroArrowsUpDown } from './ArrowsUpDown';
export { default as HeroAtSymbol } from './AtSymbol';
export { default as HeroBackspace } from './Backspace';
export { default as HeroBackward } from './Backward';
export { default as HeroBanknotes } from './Banknotes';
export { default as HeroBars2 } from './Bars2';
export { default as HeroBars3BottomLeft } from './Bars3BottomLeft';
export { default as HeroBars3BottomRight } from './Bars3BottomRight';
export { default as HeroBars3CenterLeft } from './Bars3CenterLeft';
export { default as HeroBars3 } from './Bars3';
export { default as HeroBars4 } from './Bars4';
export { default as HeroBarsArrowDown } from './BarsArrowDown';
export { default as HeroBarsArrowUp } from './BarsArrowUp';
export { default as HeroBattery0 } from './Battery0';
export { default as HeroBattery100 } from './Battery100';
export { default as HeroBattery50 } from './Battery50';
export { default as HeroBeaker } from './Beaker';
export { default as HeroBellAlert } from './BellAlert';
export { default as HeroBellSlash } from './BellSlash';
export { default as HeroBellSnooze } from './BellSnooze';
export { default as HeroBell } from './Bell';
export { default as HeroBoltSlash } from './BoltSlash';
export { default as HeroBolt } from './Bolt';
export { default as HeroBookOpen } from './BookOpen';
export { default as HeroBookmarkSlash } from './BookmarkSlash';
export { default as HeroBookmarkSquare } from './BookmarkSquare';
export { default as HeroBookmark } from './Bookmark';
export { default as HeroBriefcase } from './Briefcase';
export { default as HeroBugAnt } from './BugAnt';
export { default as HeroBuildingLibrary } from './BuildingLibrary';
export { default as HeroBuildingOffice2 } from './BuildingOffice2';
export { default as HeroBuildingOffice } from './BuildingOffice';
export { default as HeroBuildingStorefront } from './BuildingStorefront';
export { default as HeroCake } from './Cake';
export { default as HeroCalculator } from './Calculator';
export { default as HeroCalendarDays } from './CalendarDays';
export { default as HeroCalendar } from './Calendar';
export { default as HeroCamera } from './Camera';
export { default as HeroChartBarSquare } from './ChartBarSquare';
export { default as HeroChartBar } from './ChartBar';
export { default as HeroChartPie } from './ChartPie';
export { default as HeroChatBubbleBottomCenterText } from './ChatBubbleBottomCenterText';
export { default as HeroChatBubbleBottomCenter } from './ChatBubbleBottomCenter';
export { default as HeroChatBubbleLeftEllipsis } from './ChatBubbleLeftEllipsis';
export { default as HeroChatBubbleLeftRight } from './ChatBubbleLeftRight';
export { default as HeroChatBubbleLeft } from './ChatBubbleLeft';
export { default as HeroChatBubbleOvalLeftEllipsis } from './ChatBubbleOvalLeftEllipsis';
export { default as HeroChatBubbleOvalLeft } from './ChatBubbleOvalLeft';
export { default as HeroCheckBadge } from './CheckBadge';
export { default as HeroCheckCircle } from './CheckCircle';
export { default as HeroCheck } from './Check';
export { default as HeroChevronDoubleDown } from './ChevronDoubleDown';
export { default as HeroChevronDoubleLeft } from './ChevronDoubleLeft';
export { default as HeroChevronDoubleRight } from './ChevronDoubleRight';
export { default as HeroChevronDoubleUp } from './ChevronDoubleUp';
export { default as HeroChevronDown } from './ChevronDown';
export { default as HeroChevronLeft } from './ChevronLeft';
export { default as HeroChevronRight } from './ChevronRight';
export { default as HeroChevronUpDown } from './ChevronUpDown';
export { default as HeroChevronUp } from './ChevronUp';
export { default as HeroCircleStack } from './CircleStack';
export { default as HeroClipboardDocumentCheck } from './ClipboardDocumentCheck';
export { default as HeroClipboardDocumentList } from './ClipboardDocumentList';
export { default as HeroClipboardDocument } from './ClipboardDocument';
export { default as HeroClipboard } from './Clipboard';
export { default as HeroClock } from './Clock';
export { default as HeroCloudArrowDown } from './CloudArrowDown';
export { default as HeroCloudArrowUp } from './CloudArrowUp';
export { default as HeroCloud } from './Cloud';
export { default as HeroCodeBracketSquare } from './CodeBracketSquare';
export { default as HeroCodeBracket } from './CodeBracket';
export { default as HeroCog6Tooth } from './Cog6Tooth';
export { default as HeroCog8Tooth } from './Cog8Tooth';
export { default as HeroCog } from './Cog';
export { default as HeroCommandLine } from './CommandLine';
export { default as HeroComputerDesktop } from './ComputerDesktop';
export { default as HeroCpuChip } from './CpuChip';
export { default as HeroCreditCard } from './CreditCard';
export { default as HeroCubeTransparent } from './CubeTransparent';
export { default as HeroCube } from './Cube';
export { default as HeroCurrencyBangladeshi } from './CurrencyBangladeshi';
export { default as HeroCurrencyDollar } from './CurrencyDollar';
export { default as HeroCurrencyEuro } from './CurrencyEuro';
export { default as HeroCurrencyPound } from './CurrencyPound';
export { default as HeroCurrencyRupee } from './CurrencyRupee';
export { default as HeroCurrencyYen } from './CurrencyYen';
export { default as HeroCursorArrowRays } from './CursorArrowRays';
export { default as HeroCursorArrowRipple } from './CursorArrowRipple';
export { default as HeroDevicePhoneMobile } from './DevicePhoneMobile';
export { default as HeroDeviceTablet } from './DeviceTablet';
export { default as HeroDocumentArrowDown } from './DocumentArrowDown';
export { default as HeroDocumentArrowUp } from './DocumentArrowUp';
export { default as HeroDocumentChartBar } from './DocumentChartBar';
export { default as HeroDocumentCheck } from './DocumentCheck';
export { default as HeroDocumentDuplicate } from './DocumentDuplicate';
export { default as HeroDocumentMagnifyingGlass } from './DocumentMagnifyingGlass';
export { default as HeroDocumentMinus } from './DocumentMinus';
export { default as HeroDocumentPlus } from './DocumentPlus';
export { default as HeroDocumentText } from './DocumentText';
export { default as HeroDocument } from './Document';
export { default as HeroEllipsisHorizontalCircle } from './EllipsisHorizontalCircle';
export { default as HeroEllipsisHorizontal } from './EllipsisHorizontal';
export { default as HeroEllipsisVertical } from './EllipsisVertical';
export { default as HeroEnvelopeOpen } from './EnvelopeOpen';
export { default as HeroEnvelope } from './Envelope';
export { default as HeroExclamationCircle } from './ExclamationCircle';
export { default as HeroExclamationTriangle } from './ExclamationTriangle';
export { default as HeroEyeDropper } from './EyeDropper';
export { default as HeroEyeSlash } from './EyeSlash';
export { default as HeroEye } from './Eye';
export { default as HeroFaceFrown } from './FaceFrown';
export { default as HeroFaceSmile } from './FaceSmile';
export { default as HeroFilm } from './Film';
export { default as HeroFingerPrint } from './FingerPrint';
export { default as HeroFire } from './Fire';
export { default as HeroFlag } from './Flag';
export { default as HeroFolderArrowDown } from './FolderArrowDown';
export { default as HeroFolderMinus } from './FolderMinus';
export { default as HeroFolderOpen } from './FolderOpen';
export { default as HeroFolderPlus } from './FolderPlus';
export { default as HeroFolder } from './Folder';
export { default as HeroForward } from './Forward';
export { default as HeroFunnel } from './Funnel';
export { default as HeroGif } from './Gif';
export { default as HeroGiftTop } from './GiftTop';
export { default as HeroGift } from './Gift';
export { default as HeroGlobeAlt } from './GlobeAlt';
export { default as HeroGlobeAmericas } from './GlobeAmericas';
export { default as HeroGlobeAsiaAustralia } from './GlobeAsiaAustralia';
export { default as HeroGlobeEuropeAfrica } from './GlobeEuropeAfrica';
export { default as HeroHandRaised } from './HandRaised';
export { default as HeroHandThumbDown } from './HandThumbDown';
export { default as HeroHandThumbUp } from './HandThumbUp';
export { default as HeroHashtag } from './Hashtag';
export { default as HeroHeart } from './Heart';
export { default as HeroHomeModern } from './HomeModern';
export { default as HeroHome } from './Home';
export { default as HeroIdentification } from './Identification';
export { default as HeroInboxArrowDown } from './InboxArrowDown';
export { default as HeroInboxStack } from './InboxStack';
export { default as HeroInbox } from './Inbox';
export { default as HeroInformationCircle } from './InformationCircle';
export { default as HeroKey } from './Key';
export { default as HeroLanguage } from './Language';
export { default as HeroLifebuoy } from './Lifebuoy';
export { default as HeroLightBulb } from './LightBulb';
export { default as HeroLink } from './Link';
export { default as HeroListBullet } from './ListBullet';
export { default as HeroLockClosed } from './LockClosed';
export { default as HeroLockOpen } from './LockOpen';
export { default as HeroMagnifyingGlassCircle } from './MagnifyingGlassCircle';
export { default as HeroMagnifyingGlassMinus } from './MagnifyingGlassMinus';
export { default as HeroMagnifyingGlassPlus } from './MagnifyingGlassPlus';
export { default as HeroMagnifyingGlass } from './MagnifyingGlass';
export { default as HeroMapPin } from './MapPin';
export { default as HeroMap } from './Map';
export { default as HeroMegaphone } from './Megaphone';
export { default as HeroMicrophone } from './Microphone';
export { default as HeroMinusCircle } from './MinusCircle';
export { default as HeroMinusSmall } from './MinusSmall';
export { default as HeroMinus } from './Minus';
export { default as HeroMoon } from './Moon';
export { default as HeroMusicalNote } from './MusicalNote';
export { default as HeroNewspaper } from './Newspaper';
export { default as HeroNoSymbol } from './NoSymbol';
export { default as HeroPaintBrush } from './PaintBrush';
export { default as HeroPaperAirplane } from './PaperAirplane';
export { default as HeroPaperClip } from './PaperClip';
export { default as HeroPauseCircle } from './PauseCircle';
export { default as HeroPause } from './Pause';
export { default as HeroPencilSquare } from './PencilSquare';
export { default as HeroPencil } from './Pencil';
export { default as HeroPhoneArrowDownLeft } from './PhoneArrowDownLeft';
export { default as HeroPhoneArrowUpRight } from './PhoneArrowUpRight';
export { default as HeroPhoneXMark } from './PhoneXMark';
export { default as HeroPhone } from './Phone';
export { default as HeroPhoto } from './Photo';
export { default as HeroPlayCircle } from './PlayCircle';
export { default as HeroPlayPause } from './PlayPause';
export { default as HeroPlay } from './Play';
export { default as HeroPlusCircle } from './PlusCircle';
export { default as HeroPlusSmall } from './PlusSmall';
export { default as HeroPlus } from './Plus';
export { default as HeroPower } from './Power';
export { default as HeroPresentationChartBar } from './PresentationChartBar';
export { default as HeroPresentationChartLine } from './PresentationChartLine';
export { default as HeroPrinter } from './Printer';
export { default as HeroPuzzlePiece } from './PuzzlePiece';
export { default as HeroQrCode } from './QrCode';
export { default as HeroQuestionMarkCircle } from './QuestionMarkCircle';
export { default as HeroQueueList } from './QueueList';
export { default as HeroRadio } from './Radio';
export { default as HeroReceiptPercent } from './ReceiptPercent';
export { default as HeroReceiptRefund } from './ReceiptRefund';
export { default as HeroRectangleGroup } from './RectangleGroup';
export { default as HeroRectangleStack } from './RectangleStack';
export { default as HeroRocketLaunch } from './RocketLaunch';
export { default as HeroRss } from './Rss';
export { default as HeroScale } from './Scale';
export { default as HeroScissors } from './Scissors';
export { default as HeroServerStack } from './ServerStack';
export { default as HeroServer } from './Server';
export { default as HeroShare } from './Share';
export { default as HeroShieldCheck } from './ShieldCheck';
export { default as HeroShieldExclamation } from './ShieldExclamation';
export { default as HeroShoppingBag } from './ShoppingBag';
export { default as HeroShoppingCart } from './ShoppingCart';
export { default as HeroSignalSlash } from './SignalSlash';
export { default as HeroSignal } from './Signal';
export { default as HeroSparkles } from './Sparkles';
export { default as HeroSpeakerWave } from './SpeakerWave';
export { default as HeroSpeakerXMark } from './SpeakerXMark';
export { default as HeroSquare2Stack } from './Square2Stack';
export { default as HeroSquare3Stack3D } from './Square3Stack3D';
export { default as HeroSquares2X2 } from './Squares2X2';
export { default as HeroSquaresPlus } from './SquaresPlus';
export { default as HeroStar } from './Star';
export { default as HeroStopCircle } from './StopCircle';
export { default as HeroStop } from './Stop';
export { default as HeroSun } from './Sun';
export { default as HeroSwatch } from './Swatch';
export { default as HeroTableCells } from './TableCells';
export { default as HeroTag } from './Tag';
export { default as HeroTicket } from './Ticket';
export { default as HeroTrash } from './Trash';
export { default as HeroTrophy } from './Trophy';
export { default as HeroTruck } from './Truck';
export { default as HeroTv } from './Tv';
export { default as HeroUserCircle } from './UserCircle';
export { default as HeroUserGroup } from './UserGroup';
export { default as HeroUserMinus } from './UserMinus';
export { default as HeroUserPlus } from './UserPlus';
export { default as HeroUser } from './User';
export { default as HeroUsers } from './Users';
export { default as HeroVariable } from './Variable';
export { default as HeroVideoCameraSlash } from './VideoCameraSlash';
export { default as HeroVideoCamera } from './VideoCamera';
export { default as HeroViewColumns } from './ViewColumns';
export { default as HeroViewfinderCircle } from './ViewfinderCircle';
export { default as HeroWallet } from './Wallet';
export { default as HeroWifi } from './Wifi';
export { default as HeroWindow } from './Window';
export { default as HeroWrenchScrewdriver } from './WrenchScrewdriver';
export { default as HeroWrench } from './Wrench';
export { default as HeroXCircle } from './XCircle';
export { default as HeroXMark } from './XMark';
